

import { UserResponse } from '../types';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notification';
import axios from 'axios';
import { useMutation } from 'react-query';

export type LoginCredentialsDTO = {
  email: string;
  otp: string;
};


export const loginWithEmailAndPassword = (data: LoginCredentialsDTO): Promise<UserResponse> => {
  return axios.post(`${process.env.API_URL_PREFIX}/api/v1/user/otpLoginVerify`, data)
}



